const routes = [
    {
        path: "/approval-template",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
        }
    }
];

export default routes;
